/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */
import React, { type ReactNode, memo } from "react";

import isUndefined from "lodash/isUndefined";
import omitBy from "lodash/omitBy";

import { AnalyticsContext } from "@atlaskit/analytics-next";

import type { Screens } from "../constants";
/**
 * Those rules are not smart enough to detect the use case here
 */
export type Container = {
    id: string;
    type?: string;
};
export type AnalyticsContextData = {
    readonly containerId?: string;
    readonly containerType?: string;
    readonly objectType?: string;
    readonly objectId?: string;
    readonly containers?: {
        [containerName: string]: Container;
    };
    readonly tags?: string[];
    readonly sourceName?: string;
    readonly sourceType?: Screens;
    readonly attributes?: {
        [key: string]: unknown;
    };
    readonly children: ReactNode;
};

export const extractContextualData = (props: AnalyticsContextData) => {
    const { children, sourceName, sourceType, ...rest } = props;
    const source =
        sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;

    return omitBy(
        {
            source,
            ...rest
        },
        isUndefined
    );
};

export const ContextualAnalyticsData = memo<AnalyticsContextData>(
    (props: AnalyticsContextData) => {
        const data = extractContextualData(props);

        return (
            <AnalyticsContext data={data}>
                <>{props.children}</>
            </AnalyticsContext>
        );
    }
);

/* eslint-enable react/require-default-props */
